<template>
  <section id="about" class="py-16 md:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 mb-10 md:mb-0 md:pr-10">
          <div class="relative">
            <div class="absolute -top-6 -left-6 w-64 h-64 bg-primary/5 rounded-full -z-10"></div>
            <div class="absolute -bottom-6 -right-6 w-64 h-64 bg-secondary/5 rounded-full -z-10"></div>
            <img :src="require('@/assets/forlaw1.png') " alt="关于我们" class="rounded-xl shadow-xl w-full h-auto">
          </div>
        </div>
        <div class="md:w-1/2">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-700 mb-6">
            关于我们
          </h2>
          <p class="text-neutral-500 mb-6 text-lg">
            上海法烙科技有限公司成立于2025年，是一家专注于提供软件服务的科技公司。我们的使命是通过技术创新帮助企业实现数字化转型，提升竞争力。
          </p>
          <p class="text-neutral-500 mb-8 text-lg">
            我们拥有一支由经验丰富的专业人士组成的团队，在软件开发、设计等领域拥有深厚的专业知识和实践经验。我们注重技术创新和客户体验，致力于为客户提供高质量的产品和服务。
          </p>

          <div class="grid grid-cols-2 gap-6 mb-8">
            <div class="flex items-start">
              <div class="mr-4 text-primary text-2xl">
                <i class="fa fa-check-circle"></i>
              </div>
              <div>
                <h4 class="font-bold text-neutral-700 mb-1">专业团队</h4>
                <p class="text-neutral-500">经验丰富的专业人士</p>
              </div>
            </div>
            <div class="flex items-start">
              <div class="mr-4 text-primary text-2xl">
                <i class="fa fa-check-circle"></i>
              </div>
              <div>
                <h4 class="font-bold text-neutral-700 mb-1">优质服务</h4>
                <p class="text-neutral-500">客户至上的服务理念</p>
              </div>
            </div>
            <div class="flex items-start">
              <div class="mr-4 text-primary text-2xl">
                <i class="fa fa-check-circle"></i>
              </div>
              <div>
                <h4 class="font-bold text-neutral-700 mb-1">创新技术</h4>
                <p class="text-neutral-500">持续创新的技术能力</p>
              </div>
            </div>
            <div class="flex items-start">
              <div class="mr-4 text-primary text-2xl">
                <i class="fa fa-check-circle"></i>
              </div>
              <div>
                <h4 class="font-bold text-neutral-700 mb-1">高效执行</h4>
                <p class="text-neutral-500">注重效率的工作流程</p>
              </div>
            </div>
          </div>

          <a
              href="#contact" style="color:#E6733A"
              class="inline-block px-8 py-3 bg-primary hover:bg-primary/90 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            联系我们
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'About'
  }
</script>
